export default class typeSwitcher {
  constructor(root, youtubePlayer) {
    this.root = typeof root === 'string'
    ? document.querySelector(root)
    : root;
  if (!this.root) return;

  this.youtubePlayer = youtubePlayer;

    this.buttons = this.root.querySelectorAll('.js-type-trigger');
    if (this.buttons.length === 0) return;

    this.init();
  }

  showContent(id) {
    const contents = this.root.querySelectorAll('.content');
    contents.forEach(content => {
      content.style.display = (content.id === id) ? 'grid' : 'none';
    });
  }

  setActiveButton(targetId) {
    this.buttons.forEach(button => {
      const buttonTarget = button.getAttribute('data-target');
      if (buttonTarget === targetId) {
        button.classList.add('is-active');
      } else {
        button.classList.remove('is-active');
      }
    });
  }

  init() {
    // 初期表示
    const defaultId = 'content1';
    this.showContent(defaultId);
    this.setActiveButton(defaultId);

    this.buttons.forEach(button => {
      button.addEventListener('click', () => {
        const target = button.getAttribute('data-target');
        this.showContent(target);
        this.setActiveButton(target);
        this.youtubePlayer.pauseAll();
      });
    });
  }
}